import { createStructuredSelector } from 'reselect'
import { selectUserFirstName } from 'src/store/selectors/layout'
import {
  selectCustomerPhone,
  selectCompanyName,
  selectCustomerEmail,
  selectName,
  selectCustomerPhotoUri,
  selectCustomerNMLS
} from 'src/store/selectors/customerProfile'

export const selectIntroProps = createStructuredSelector({
  customerName: selectName,
  email: selectCustomerEmail,
  photoUri: selectCustomerPhotoUri,
  nmls: selectCustomerNMLS,
  toName: selectUserFirstName,
  companyName: selectCompanyName,
  phone: selectCustomerPhone
})
